<script lang='ts'>
  import '$lib/app.css'
</script>

<slot />
